import axios from 'axios';

export const malimaxContainerApi = axios.create({
    baseURL: `${process.env.REACT_APP_BACKEND!}api/malimax-container`,
    headers: {
        'Content-Type': 'application/json'
    }
})